<!--  -->
<template>
  <div class="publicItems">
    <div class="selectionArea">
      <!-- <div class="item">
        <span class="title">请输入部门id:</span>
        <el-input
          v-model="parameter.department_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div> -->
      <!-- <div class="item">
        <span class="title">广告主名称:</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">广告主标签:</span>
        <el-input
          v-model="parameter.account_tag"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div> -->
      <!-- <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button> -->
      <!-- <el-button
        type="primary"
        icon="el-icon-circle-plus"
        @click="func"
      >添加</el-button> -->
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%;margin-top: 20px;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
        />
        <el-table-column
          prop="name"
          label="部门名称"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
        />
        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template scope="scope">
            <el-button type="primary" @click="choose(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { iaaMaterialReportdepartmentlistNative } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getDataList()
    },
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await iaaMaterialReportdepartmentlistNative(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    choose(item) {
      this.$emit('callback', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>

